/*
 * @name: 
 * @Author: zxc
 * @Date: 2021-08-23 09:26:20
 * @LastEditors: zxc
 * @LastEditTime: 2021-08-25 16:15:17
 */
import Cookies from 'js-cookie'

const TokenKey = 'portalSiteToken'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js